import React, { useEffect, useRef, useState } from "react";
import styles from "./contact.module.scss";
import ContactForm from "../contactForm/ContactForm";

const Contact = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [ref, visible]);

  return (
    <div className={styles.container} ref={ref} id="contact">
      <div className={styles.wrapper}>
        <div
          className={
            visible ? styles.left + " " + styles.leftAnimation : styles.left
          }
        >
          <h2 className={styles.heading}>We're Here to Help Your Database</h2>
          <div className={styles.description}>
            Take control of your storage with Megam. Track your spending, save
            smartly all in one easy-to-use.
          </div>
        </div>
        <div
          className={
            visible ? styles.right + " " + styles.rightAnimation : styles.right
          }
        >
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;